export default __webpack_public_path__ + "static/media/thumb03_invitation2@2x.8af4fc42.png";